import { CircularProgress, Grid } from '@mui/material';

const LoadingSpinner = () => (
  <Grid container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10 }}>
    <CircularProgress color="primary" size={40} />
  </Grid>
);

export default LoadingSpinner;
